var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarYellow = function SvgStarYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBD42",
    fillRule: "evenodd",
    d: "M8 .667c.254 0 .485.144.598.371l1.905 3.86 4.26.622a.667.667 0 0 1 .369 1.137L12.05 9.66l.727 4.241a.667.667 0 0 1-.967.703L8 12.6l-3.81 2.003a.667.667 0 0 1-.967-.703l.727-4.24L.868 6.656a.667.667 0 0 1 .369-1.137l4.26-.623 1.905-3.859A.67.67 0 0 1 8 .667",
    clipRule: "evenodd"
  })));
};
export default SvgStarYellow;